import { Button, Card, Form, Segmented, Space, Drawer } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SeoForms from '../../SeoConfig/SeoForms';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { navigate } from '../../../../navigation';
import UploadPage from '../../../Page/UploadPage';
import PageBuilder_1 from './PageBuilder_1';
import { PageBuilderServices } from '../../../Services/PageBuilderServices';
import { formatDateTime } from '../../Customs/formatDateTime';
import { notify } from '../../../customs/NotifyProvider';

const PageConfigSelect = () => {
  const location = useLocation();
  const { record } = location.state || {};

  const [activeSegment, setActiveSegment] = useState('content');
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [form] = Form.useForm();

  const isEdit = Boolean(record?.id);

  const onFinish = async (values) => {
    // console.log(values);

    const payload = {
      ...values,
      slug_id: record?.id,
      updated_on: formatDateTime(),
      added_on: formatDateTime()
    }
    console.log(payload);

    const request = await PageBuilderServices.pbc_seo_insert(payload)

    if (request.status) {
      notify.success("Page Updated", request.message)
    } else {
      notify.warning("Something went wrong!", request.message)
    }

  };


const getPageSeoValue = async (id) => {
  try {
    const request = await PageBuilderServices.pbc_seo_by_slug(id);
    
    if (request?.data && request.data.length > 0) {
      const seoData = request.data[0];

      const { id, added_on, updated_on, slug_id, ...formValues } = seoData;

      form.setFieldsValue(formValues);
    }
  } catch (error) {
    console.error("Error fetching SEO data:", error);
  }
};

  useEffect(()=>{
    getPageSeoValue(record?.id)
  },[record?.id]);

  return (
    <Card
      title={
        <Space>
          <ArrowLeftOutlined onClick={() => navigate(-1)} />
          Page Configurations : {record?.title} | Page ID : {record?.id}
        </Space>
      }
      extra={
        <Button type="primary" ghost onClick={() => setGalleryOpen(true)}>
          Image Gallery
        </Button>
      }
    >
      {/* SEGMENT SWITCH */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
        <Segmented
          size="large"
          block
          value={activeSegment}
          onChange={setActiveSegment}
          options={[
            { label: 'Page Content', value: 'content' },
            { label: 'SEO', value: 'seo' },
          ]}
          style={{
            width: '70%',
            padding: 6,
            borderRadius: 8,
          }}
        />
      </div>

      {/* PAGE CONTENT */}
      {activeSegment === 'content' && (
        <>
          <PageBuilder_1 slug_id={record?.id} record={record} />
        </>
      )}

      {/* SEO */}
      {activeSegment === 'seo' && (
        <SeoForms slug_id={record?.id} form={form} onFinish={onFinish} />
      )}

      {/* IMAGE GALLERY DRAWER */}
      <Drawer
        title=""
        open={galleryOpen}
        onClose={() => setGalleryOpen(false)}
        width={700}
        destroyOnClose
        placement="right"
      >
        <UploadPage pageId={record?.id} />
      </Drawer>
    </Card>
  );
};

export default PageConfigSelect;
